import React from 'react';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress'; 
import Button from '../Button/Button';
import { ReactNode } from 'react';

interface SaveCancelButtonsProps {
  onSave?: () => void;
  onCancel?: () => void;
  containerStyle?: object;
  cancelButtonStyle?: object;
  saveButtonStyle?: object;
  loading?: boolean;
  saveValue?: ReactNode | string;
  cancelValue?: ReactNode | string;
  customCancelDisabled?: boolean;
  customSaveDisabled?: boolean;
  showSaveButton?: boolean;
  showCancelButton?: boolean;
}

const SaveCancelButtons: React.FC<SaveCancelButtonsProps> = ({
  onSave,
  onCancel,
  containerStyle = {},
  cancelButtonStyle = {},
  saveButtonStyle = {},
  loading = false,
  saveValue = 'SAVE',
  cancelValue = 'CANCEL',
  customCancelDisabled = false,
  customSaveDisabled = false,
  showSaveButton = true,
  showCancelButton = true,
}) => {
  return (
    <FormControl component="fieldset" sx={{ width: '100%', marginTop: '20px', ...containerStyle }}>
      <Stack
        direction={{ xs: 'row', sm: 'row' }}
        alignItems="center"
        justifyContent="flex-end"
        sx={{ width: '100%' }}
        gap={{ xs: 2, md: 3 }}
      >
        {showCancelButton && (
          <Button
            variant="outlined"
            onClick={onCancel}
            sx={{  
              ...cancelButtonStyle,
            }}
            disabled={loading || customCancelDisabled}
          >
            {cancelValue}
          </Button>
        )}

        {showSaveButton && (
          <Button
            variant="contained"
            onClick={onSave}
            sx={{
              ...saveButtonStyle,
            }}
            disabled={loading || customSaveDisabled}
          >
            {loading ? (
              <>
                Saving
                <CircularProgress
                  size={25}
                  sx={{ marginLeft: '10px', marginRight: 1, color: 'white' }}
                />
              </>
            ) : (
              saveValue
            )}
          </Button>
        )}
      </Stack>
    </FormControl>
  );
};

export default SaveCancelButtons;
